import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { CloseDialog } from '../../shared/dialog-close/dialog-close';
import { FormGroup, FormControl, Validators } from '../../../../node_modules/@angular/forms';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { Business } from '../models/business.model';
import { Tag } from '../../shared/models/tag.model';
import { TagService } from '../../shared/services/tag.service';
import { hasTag } from '../../util/tag-utils';
import { AirportService } from '../../airport/airport.service';


@Component({
  selector: 'app-select-magazine-dialog',
  templateUrl: './select-magazine-dialog.component.html',
  styleUrls: ['./select-magazine-dialog.component.scss']
})
export class SelectMagazineDialogComponent implements OnInit {

  business: Business;
  formGroup: FormGroup;
  isLoading = false;

  allTags: Tag[];
  NoMagTag: Tag;
  FTMagTag: Tag;
  PilotMagTag: Tag;
  TurbinePilotMagTag: Tag;
  getsNoMagazine: boolean;
  getsFTMagazine: boolean;
  getsPilotMagazine: boolean;
  getsTurbinePilotMagazine: boolean;
  currentMag: string;

  constructor(private _dialogRef: MatDialogRef<SelectMagazineDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private _airportService: AirportService,
              private _businessManagerService: BusinessManagerService,
              private _tagService: TagService,
              public _snackBar: MatSnackBar) {
    this.business = data.business;
  }

  async ngOnInit() {
    this.isLoading = true;
    this.business = await this._airportService.getBusiness(this.business.id.toString());
    this.allTags = await this._tagService.getAllTags();
    this.NoMagTag = await this._tagService.findTagByName(this.allTags, 'Magazine::No Magazine');
    this.getsNoMagazine = hasTag(this.business.tags, 'Magazine::No Magazine');
    this.FTMagTag = await this._tagService.findTagByName(this.allTags, 'Magazine::Flight Training');
    this.getsFTMagazine = hasTag(this.business.tags, 'Magazine::Flight Training');
    this.PilotMagTag = await this._tagService.findTagByName(this.allTags, 'Magazine::AOPA Pilot');
    this.getsPilotMagazine = hasTag(this.business.tags, 'Magazine::AOPA Pilot');
    this.TurbinePilotMagTag = await this._tagService.findTagByName(this.allTags, 'Magazine::AOPA Turbine Pilot');
    this.getsTurbinePilotMagazine = hasTag(this.business.tags, 'Magazine::AOPA Turbine Pilot');
    if (this.getsNoMagazine) {
      this.currentMag = 'NoMag';
    } else if (this.getsFTMagazine) {
      this.currentMag = 'AOPAFlightTraining';
    } else if (this.getsPilotMagazine) {
      this.currentMag = 'AOPAPilot';
    } else if (this.getsTurbinePilotMagazine) {
      this.currentMag = 'AOPATurbinePilot';
    }
    let startingMag = 'NoMag';
    if (this.currentMag) {
      startingMag = this.currentMag;
    }

    this.formGroup = new FormGroup({
      magType: new FormControl(startingMag, [Validators.required])
    });
    this._dialogRef.backdropClick().subscribe(() => {
      const CLOSE_DIALOG = new CloseDialog();
      CLOSE_DIALOG.cancelButtonClicked = true;
      this._dialogRef.close(CLOSE_DIALOG);
    });
    this.isLoading = false;
  }

  async onSubmit() {
    const CLOSE_DIALOG = new CloseDialog();
    const ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
    const BUSINESS_ID = this.business.id;
    try {
      let deleteTagID: number;
      if (this.currentMag === 'NoMag') {
        deleteTagID = this.NoMagTag.tagId;
      } else if (this.currentMag === 'AOPAFlightTraining') {
        deleteTagID = this.FTMagTag.tagId;
      } else if (this.currentMag === 'AOPAPilot') {
        deleteTagID = this.PilotMagTag.tagId;
      } else if (this.currentMag === 'AOPATurbinePilot') {
        deleteTagID = this.TurbinePilotMagTag.tagId;
      }
      if (deleteTagID) {
        await this._tagService.deleteTag(deleteTagID, BUSINESS_ID);
      }
      let TAG_ID: number;
      if (this.formGroup.controls['magType'].value === 'NoMag') {
        TAG_ID = this.NoMagTag.tagId;
      } else if (this.formGroup.controls['magType'].value === 'AOPAFlightTraining') {
        TAG_ID = this.FTMagTag.tagId;
      } else if (this.formGroup.controls['magType'].value === 'AOPAPilot') {
        TAG_ID = this.PilotMagTag.tagId;
      } else if (this.formGroup.controls['magType'].value === 'AOPATurbinePilot') {
        TAG_ID = this.TurbinePilotMagTag.tagId;
      }
      await this._tagService.postTag(TAG_ID, BUSINESS_ID);
      this._snackBar.open('Magazine selection successfully saved.', 'Note', {
        duration: 6000
      });
      CLOSE_DIALOG.success = true;
    } catch (e) {
      this._snackBar.open(ERROR_MSG, 'Error', {
        duration: 6000
      });
      throw e;
    }
    this._dialogRef.close(CLOSE_DIALOG);
  }

}
